import { Outlet } from "react-router-dom";
import AppBar from "../components/appBar";
import Inqueries from "../components/Inqueries";
import MainFooter from "../components/MainFooter";
import Consultation from "../components/Consultation";

function HomeLayout() {
  return (
    <>
      <div className=" flex flex-col items-center bg-theme-background bg-no-repeat bg-left-bottom bg-60% lg:bg-50%  overflow-x-hidden h-screen overflow-y-auto">
        <div className="top-0 z-[10000] sticky w-full">
          <AppBar />
        </div>
        <div>
          <Inqueries />
        </div>
        <Outlet />
        <MainFooter />
      </div>
    </>
  );
}

export default HomeLayout;
